import { Controller } from "@hotwired/stimulus"
import { marked } from "marked"

const STORAGE_KEY = "chatbot_history"
const HISTORY_TTL = 6 * 60 * 60 * 1000

export default class extends Controller {
  static targets = ["popup", "messages", "input", "sendBtn"]

  connect() {
    if (this.messagesTarget.children.length === 0) {
      this.restoreHistory()
    }
  }

  toggle() {
    this.popupTarget.classList.toggle("chatbot-popup--open")
    if (this.popupTarget.classList.contains("chatbot-popup--open")) {
      this.inputTarget.focus()
      this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
    }
  }

  keydown(event) {
    if (event.key === "Enter" && (event.ctrlKey || event.metaKey)) {
      event.preventDefault()
      this.send()
    }
  }

  async send() {
    const message = this.inputTarget.value.trim()
    if (!message) return

    this.inputTarget.value = ""

    const history = this.loadHistory()
    this.appendMessage("user", message)

    const loadingEl = this.appendLoading()
    this.setSendDisabled(true)

    try {
      const response = await fetch("/chatbot/message", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        },
        body: JSON.stringify({ message, history })
      })

      const data = await response.json()
      loadingEl.remove()

      if (response.ok) {
        this.appendMessage("assistant", data.message)
      } else {
        this.appendMessage("error", data.error || "Nastala chyba. Zkuste to prosím znovu.")
      }
    } catch {
      loadingEl.remove()
      this.appendMessage("error", "Chyba připojení. Zkuste to prosím znovu.")
    } finally {
      this.setSendDisabled(false)
      this.inputTarget.focus()
    }
  }

  appendMessage(role, text) {
    const el = this.renderMessage(role, text)
    this.messagesTarget.appendChild(el)
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
    if (role === "user" || role === "assistant") {
      this.saveMessage(role, text)
    }
    return el
  }

  appendLoading() {
    const el = document.createElement("div")
    el.className = "chatbot-message chatbot-message--loading"
    el.innerHTML = "<span></span><span></span><span></span>"
    this.messagesTarget.appendChild(el)
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
    return el
  }

  async report() {
    const history = this.loadHistory()
    if (history.length === 0) {
      alert("Žádná konverzace k nahlášení.")
      return
    }

    const note = prompt("Volitelná poznámka (co bylo špatně / co bylo dobré):")
    if (note === null) return  // zrušeno

    try {
      await fetch("/chatbot/report", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ conversation: history, note })
      })
      alert("Konverzace nahlášena. Díky!")
    } catch {
      alert("Nepodařilo se odeslat report.")
    }
  }

  setSendDisabled(disabled) {
    this.sendBtnTarget.disabled = disabled
    this.inputTarget.disabled   = disabled
  }

  renderMessage(role, text) {
    const el = document.createElement("div")
    el.className = `chatbot-message chatbot-message--${role}`
    if (role === "assistant") {
      try { el.innerHTML = marked.parse(text) } catch { el.textContent = text }
    } else {
      el.textContent = text
    }
    return el
  }

  loadHistory() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY)
      if (!raw) return []
      const cutoff = Date.now() - HISTORY_TTL
      return JSON.parse(raw).filter(m => m.ts > cutoff)
    } catch {
      return []
    }
  }

  saveMessage(role, content) {
    const history = this.loadHistory()
    history.push({ role, content, ts: Date.now() })
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(history.slice(-50)))
    } catch {}
  }

  restoreHistory() {
    this.loadHistory().forEach(m => {
      this.messagesTarget.appendChild(this.renderMessage(m.role, m.content))
    })
    if (this.messagesTarget.children.length > 0) {
      this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
    }
  }
}
